import React, { useState, useEffect } from "react";
import { ReactSVG } from "react-svg";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useParams, useNavigate } from "react-router-dom";

import {
  cardiacMedEnum,
  oralMedEnum,
  otherPresEnum,
  nonPresEnum,
  drugTypes,
} from "./data";
import ConfirmationModalNew from "../../../../common/ConfirmationModalNew";
import Button from "../../../../common/Button";
import MedicationCreate from "./MedicationCreate";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchMedications,
  setClinicalServiceSteps,
  updateClinicalService,
} from "../../../../../redux/modules/clinical-services/actions";
import ChartNav from "../../../../common/ChartNav";
import Medications from "../../medications/medications";
import Steps from "../../Steps";
import PrescriptionMedicationsAlert from "../../alerts/PrescriptionMedicationsAlert";
import EndServiceModel from "../../../../common/EndServiceModel";
import {
  AlertConfirmationTypes,
  MinorAilmentStep,
} from "../../../../../helpers/constant";
import { scrollX } from "../../../../../helpers/functions";
import SubNavigation from "../../common/sub-navigation";
import NewToolTip from "../../../../common/New-ToolTip";
import { getValidStep, updateStepsValidity } from "../../../text/data";

const DrugInduced = () => {
  const { clinicalServiceObj, medications, clinicalServiceSteps } = useSelector(
    (state) => state.clinicalService
  );
  const { showReferral } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const { currentStep, currentSubStep } =
    clinicalServiceObj.initialAssessment.initialAssessmentForm;
  const [continueService, setContinueService] = useState(false);
  const [showRef, setShowRef] = useState(showReferral ?? false);
  const { id: patientId, serviceId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [otherDrugs, setOtherDrugs] = useState([]);
  const [drugInducedCard, setDrugInducedCard] = useState(1);
  const [maxStep, setMaxSetp] = useState(null);
  const [cardiacVals, setCardiacVals] = useState([]);
  const [title, setTitle] = useState("");
  const [cardiacCreateVals, setCardiacCreateVals] = useState([]);
  const [addDrugClass, setAddDrugClass] = useState(null);
  const [otherPresCreateVals, setOtherPresCreateVals] = useState([]);
  const [nonPresCreateVals, setNonPresCreateVals] = useState([]);
  const [oralVal, setOralVal] = useState(null);
  const [oralCreateVals, setOralCreateVals] = useState([]);
  const [otherPresVals, setOtherPresVals] = useState([]);
  const [nonPresVals, setNonPresVals] = useState([]);
  const [clinicalAnalysis, setClinicalAnalysis] = useState(false);
  const [completeSubStep, setCompleteSubStep] = useState(false);
  const [cardiacReVisit, setCardiacReVisit] = useState(false);
  const [otherPresReVisit, setOtherPresReVisit] = useState(false);
  const [nonPresReVisit, setNonPresReVisit] = useState(false);
  const [isContinueClicked, setIsContinueClicked] = useState(false);
  const [showclinicalAnalysis, setShowClinicalAnalysis] = useState(false);
  const [medicationType, setMedicationType] = useState(null);
  const [medicationStepCount, setMedicationStepCount] = useState(null);
  const [currentCardType, setCurrentCardType] = useState(null); // 'cardiac', 'oral', 'otherPres', 'nonPres'
  const [selectedMedication, setSelectedMedication] = useState();

  const [isCardiacUpdate, setIsCardiacUpdate] = useState(false);
  const [isOralUpdate, setIsOralUpdate] = useState(false);
  const [isOtherPresUpdate, setIsOtherPresUpdate] = useState(false);
  const [isNonPresUpdate, setIsNonPresUpdate] = useState(false);
  const [drugInducedObj, setDrugInducedObj] = useState(null);
  const [prescriptionMedication, setPrescriptionMedication] = useState(null);

  const [prescriptionMeds, setPrescriptionMeds] = useState(null);
  const [nonPrescriptionMeds, setNonPrescriptionMeds] = useState(null);
  const [clickedEndService, setClickedEndService] = useState(false);
  const [alertConfirmation, setAlertConfirmation] = useState(0);
  const [alertExplaination, setAlertExplaination] = useState("");

  useEffect(() => {
    if (clickedEndService) {
      onNext();
      setClickedEndService(false);
    }
  }, [clinicalServiceSteps, clickedEndService]);

  //state management
  useEffect(() => {
    dispatch(fetchMedications(patientId));
  }, []);

  useEffect(() => {
    if (
      clinicalServiceObj.initialAssessment.initialAssessmentForm !==
        undefined &&
      clinicalServiceObj.initialAssessment.initialAssessmentForm
        .clinicalAssessment !== null &&
      (clinicalServiceObj.initialAssessment.initialAssessmentForm
        ?.clinicalAssessment.cardiacMedications !== null ||
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment?.cardiacMedications !== null)
    ) {
      let drugInduced =
        clinicalServiceObj.initialAssessment.initialAssessmentForm
          ?.clinicalAssessment;

      if (drugInduced.cardiacMedications !== null)
        setPrescriptionMedication(drugInduced.anyPrescriptionMedication);

      setCardiacVals(drugInduced.cardiacMedications);
      setOtherPresVals(drugInduced.otherPrescriptionMedications);
      setNonPresVals(drugInduced.nonPrescriptionMedications);
      setOralVal(drugInduced.oralContraceptives);

      if (drugInduced?.cardiacMedications?.length > 0)
        setPrescriptionMeds(true);
      else setPrescriptionMeds(false);

      if (drugInduced.nonPrescriptionMedications?.length > 0)
        setNonPrescriptionMeds(true);
      else setNonPrescriptionMeds(false);

      setShowClinicalAnalysis(true);
      setCompleteSubStep(true);
      setClinicalAnalysis(true);
      // Set the card based on what's been completed
      if (prescriptionMeds && nonPrescriptionMeds) {
        setDrugInducedCard(4);
      } else if (prescriptionMeds) {
        setDrugInducedCard(3);
      } else if (nonPrescriptionMeds) {
        setDrugInducedCard(4);
      } else {
        setDrugInducedCard(1);
      }
      setTimeout(() => {
        scrollX("drug-induced", 900);
      }, 400);
    } else {
      setOpenPrescriptionMedicationAlert(true);
      setDrugInducedCard(1);
    }
  }, [clinicalServiceObj]);

  useEffect(() => {
    if (drugInducedObj !== null) {
      if (
        drugInducedCard === 1 &&
        drugInducedObj.cardiacVals !== undefined &&
        drugInducedObj.cardiacVals.length > 0
      ) {
        setCardiacReVisit(true);
      } else if (
        drugInducedCard === 3 &&
        drugInducedObj.otherPresVals !== undefined &&
        drugInducedObj.otherPresVals.length > 0
      ) {
        setOtherPresReVisit(true);
      } else if (
        drugInducedCard === 4 &&
        drugInducedObj.nonPresVals !== undefined &&
        drugInducedObj.nonPresVals.length > 0
      ) {
        setNonPresReVisit(true);
      }
    }
  }, [drugInducedCard]);

  useEffect(() => {
    if (
      isOralUpdate ||
      isCardiacUpdate ||
      isNonPresUpdate ||
      isOtherPresUpdate
    ) {
      setCompleteSubStep(false);
      setClinicalAnalysis(false);
      setContinueService(false);
    }
  }, [isOralUpdate, isCardiacUpdate, isNonPresUpdate, isOtherPresUpdate]);

  //whenn to show final analysis card
  useEffect(() => {
    if (prescriptionMeds !== null && nonPrescriptionMeds !== null) {
      if (prescriptionMeds) {
        if (nonPrescriptionMeds)
          setShowClinicalAnalysis(
            cardiacVals.length > 0 &&
              oralVal &&
              otherPresVals.length > 0 &&
              nonPresVals.length > 0
          );
        else
          setShowClinicalAnalysis(
            cardiacVals.length > 0 && oralVal && otherPresVals.length > 0
          );
      } else {
        if (nonPrescriptionMeds)
          setShowClinicalAnalysis(nonPresVals.length > 0);
        else setShowClinicalAnalysis(true);
      }
    }
    if (isCardiacUpdate || isOralUpdate || isOtherPresUpdate || isNonPresUpdate)
      setClinicalAnalysis(false);
  }, [
    prescriptionMeds,
    nonPrescriptionMeds,
    cardiacVals,
    oralVal,
    otherPresVals,
    nonPresVals,
  ]);

  const updateStepsVisibility = async (disable = false) => {
    const updatedServiceSteps = updateStepsValidity(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      disable
    );
    await dispatch(setClinicalServiceSteps(updatedServiceSteps));
  };

  const onNext = () => {
    if (currentStep <= clinicalServiceSteps.length) {
      const { nextStep, nextSubStep } = getValidStep(
        clinicalServiceSteps,
        currentStep,
        currentSubStep,
        1
      );

      let updatedSteps = {
        showReferral: showRef,
        currentStep: nextStep,
        currentSubStep: nextSubStep,
        serviceSteps: clinicalServiceSteps,
      };

      // if (!isContinueClicked) {
      updatedSteps.clinicalAssessment = {
        cardiacMedications: cardiacVals == ["None"] ? [] : cardiacVals,
        oralContraceptives: oralVal === "" ? null : oralVal,
        otherPrescriptionMedications:
          otherPresVals == ["None"] ? [] : otherPresVals,
        nonPrescriptionMedications: nonPresVals == ["None"] ? [] : nonPresVals,
        anyPrescriptionMedication: prescriptionMedication,
        drugInducedConfirmationType: alertConfirmation,
        drugInducedExplaination: alertExplaination,
      };
      // }
      dispatch(updateClinicalService(serviceId, updatedSteps));
    }
  };

  const onPrevious = () => {
    const { nextStep, nextSubStep } = getValidStep(
      clinicalServiceSteps,
      currentStep,
      currentSubStep,
      -1
    );
    const updatedSteps = { currentStep: nextStep, currentSubStep: nextSubStep };
    dispatch(updateClinicalService(serviceId, updatedSteps));
  };

  var noteDescription = (
    <div className="p-4 text-teal-300 bg-white text-body-sm">
      Review the initial questions for Drug-Induced Allergic Rhinitis
    </div>
  );

  const [openPrescriptionMedicationAlert, setOpenPrescriptionMedicationAlert] =
    useState(false);
  const [openNoDrugDialog, setOpenNoDrugDialog] = useState(false);
  const [openUncodedDrugAlert, setOpenUncodedDrugAlert] = useState(false);
  const [openDrugInducedNasalAlert, setOpenDrugInducedNasalAlert] =
    useState(false);
  const [openDrugInducedMultiCondAlert, setOpenDrugInducedMultiCondAlert] =
    useState(false);
  const [openDrugInducedOralAlert, setOpenDrugInducedOralAlert] =
    useState(false);
  //Drug Induced Models
  const [showCardiacCreateSlider, setShowCardiacCreateSlider] = useState(false);

  // Generic multi-selection handler for array-based selections
  const handleMultiSelection = (val, currentVals, setVals, createVals, setCreateVals, noneValue = "None", setUpdateFlag = null) => {
    if (setUpdateFlag) setUpdateFlag(true);

    if (val === noneValue) {
      !currentVals.includes(val)
        ? setVals([noneValue])
        : setVals([]);
      setCreateVals([]);
    } else {
      if (currentVals.includes(noneValue)) {
        setVals([val]);
        setCreateVals([]);
      } else {
        if (currentVals.includes(val)) {
          setVals(currentVals.filter((item) => item !== val));
          setCreateVals(createVals.filter((item) => item.name !== val));
        } else {
          setVals([...currentVals, val]);
        }
      }
    }
    event?.stopPropagation();
  };

  const cardiacMultiSelection = (val) => {
    handleMultiSelection(val, cardiacVals, setCardiacVals, cardiacCreateVals, setCardiacCreateVals, "None", setIsCardiacUpdate);
  };

  const oralMultiSelection = (val) => {
    setIsOralUpdate(true);

    if (val === "Does not apply") {
      setOralCreateVals([]);
      setOralVal(val);
    } else {
      if (oralVal === val) {
        setOralVal("");
        if (oralCreateVals.includes(val)) setOralCreateVals([]);
      } else {
        setOralVal(val);
      }
    }
    event.stopPropagation(); // Stop the event from bubbling up
    // }
  };

  // Generic function to toggle medication in createVals
  const toggleCreateVal = (createVals, setCreateVals, val, updateMaxStep = false) => {
    if (createVals.some((i) => i.name === val)) {
      if (updateMaxStep) {
        setMaxSetp(
          createVals.filter((item) => item.name !== val).length > 1
            ? createVals.filter((item) => item.name !== val).length
            : null
        );
      }
      setCreateVals(createVals.filter((item) => item.name !== val));
    } else {
      if (updateMaxStep) {
        setMaxSetp(
          createVals.filter((item) => !item.isAdded).length !== 0
            ? createVals.filter((item) => !item.isAdded).length + 1
            : null
        );
      }
      setCreateVals([...createVals, { name: val, isAdded: false }]);
    }
  };

  const cardiacCreateMultiSelection = (event, val, index) => {
    event.stopPropagation();
    setMedicationType(drugTypes.Prescription);
    const option = cardiacMedEnum.options.find((o) => o.value === val);
    setSelectedMedication(option ? option.header : val);
    setAddDrugClass(index + "_cardiac");
    toggleCreateVal(cardiacCreateVals, setCardiacCreateVals, val, true);
    setShowCardiacCreateSlider(true);
  };

  const oralCreateMultiSelection = (event, val, index) => {
    event.stopPropagation();
    setMedicationType(drugTypes.Prescription);
    setTitle("Oral Contraceptive");
    setAddDrugClass(index + "_oral");
    toggleCreateVal(oralCreateVals, setOralCreateVals, val);
    setShowCardiacCreateSlider(true);
  };

  const otherPresMultiSelection = (val) => {
    handleMultiSelection(val, otherPresVals, setOtherPresVals, otherPresCreateVals, setOtherPresCreateVals, "None", setIsOtherPresUpdate);
  };

  const otherPresCreateMultiSelection = (event, val, index) => {
    event.stopPropagation();
    setMedicationType(drugTypes.Prescription);
    const option = otherPresEnum.options.find((o) => o.value === val);
    setSelectedMedication(option ? option.header : val);
    setAddDrugClass(index + "_otherPres");
    toggleCreateVal(otherPresCreateVals, setOtherPresCreateVals, val, true);
    setShowCardiacCreateSlider(true);
  };

  const nonPresMultiSelection = (val) => {
    handleMultiSelection(val, nonPresVals, setNonPresVals, nonPresCreateVals, setNonPresCreateVals, "None", setIsNonPresUpdate);
  };

  const nonPresCreateMultiSelection = (event, val, index) => {
    event.stopPropagation();
    setMedicationType(drugTypes.Additional);
    const option = nonPresEnum.options.find((o) => o.value === val);
    setSelectedMedication(option ? option.header : val);
    setAddDrugClass(index + "_nonPres");
    toggleCreateVal(nonPresCreateVals, setNonPresCreateVals, val, true);
    setShowCardiacCreateSlider(true);
  };

  const getSelectedMedications = () => {
    let medicationList = [];
    if (cardiacVals.length > 0) {
      medicationList = medicationList.concat(
        cardiacMedEnum.options
          .filter((val) =>
            cardiacVals.filter((val) => val != "None").includes(val.value)
          )
          .map((val) => val.header)
      );
    }

    if (otherPresVals.length > 0) {
      medicationList = medicationList.concat(
        otherPresEnum.options
          .filter((val) =>
            otherPresVals.filter((val) => val != "None").includes(val.value)
          )
          .map((val) => val.header)
      );
    }

    if (nonPresVals.length > 0) {
      medicationList = medicationList.concat(
        nonPresEnum.options
          .filter((val) =>
            nonPresVals.filter((val) => val != "None").includes(val.value)
          )
          .map((val) => val.header)
      );
    }

    if (medicationList.indexOf("Other") >= 0) {
      medicationList = medicationList.filter((val) => val !== "Other");
      medicationList = [...medicationList, otherDrugs];
    }

    return (
      <ul className="pl-4 list-disc text-body-md">
        {medicationList.map((val) => (
          <li>{val}</li>
        ))}
      </ul>
    );
  };

  const CARD_CONFIG = {
    1: {
      title: "Cardiac Medications",
      enum: cardiacMedEnum,
      vals: cardiacVals,
      createVals: cardiacCreateVals,
      cardType: "cardiac",
      medType: drugTypes.Prescription,
      tooltips: {
        "Alpha Blockers": { id: "alphaBlockerNote", content: "Doxazosin, Prazosin" },
      },
    },
    2: {
      title: "Oral Contraceptives",
      enum: oralMedEnum,
      vals: oralVal,
      createVals: oralCreateVals,
      cardType: "oral",
      medType: drugTypes.Prescription,
      isSingleSelect: true,
      excludeValues: ["Does not apply", "No"],
    },
    3: {
      title: "Other Prescription Medications",
      enum: otherPresEnum,
      vals: otherPresVals,
      createVals: otherPresCreateVals,
      cardType: "otherPres",
      medType: drugTypes.Prescription,
      tooltips: {
        "NSAIDS": { id: "otherNsaids", content: "Non-steroidal anti-inflammatory drugs" },
        "Nasal": { id: "otherNasal", content: "If using more than 3 to 7 days" },
      },
    },
    4: {
      title: "Non-Prescription Medications",
      enum: nonPresEnum,
      vals: nonPresVals,
      createVals: nonPresCreateVals,
      cardType: "nonPres",
      medType: drugTypes.Additional,
      tooltips: {
        "Nasal Decongestants": { id: "nasalDecongestants", content: "If using more than 3 to 7 days" },
        "NSAIDS": { id: "nsaids", content: "Non-steroidal anti-inflammatory drugs" },
      },
    },
  };

  const getNextCard = (currentCard) => {
    const cardFlow = {
      1: prescriptionMeds ? 2 : nonPrescriptionMeds ? 4 : null, // Cardiac -> Oral or NonPres
      2: prescriptionMeds ? 3 : nonPrescriptionMeds ? 4 : null, // Oral -> OtherPres or NonPres
      3: nonPrescriptionMeds ? 4 : null, // OtherPres -> NonPres
      4: null, // NonPres -> Analysis
    };
    return cardFlow[currentCard] ?? null;
  };

  const getCardVisibilityClasses = (cardNumber) => {
    const isActive = drugInducedCard === cardNumber;
    return {
      container: `${!isActive ? "opacity-40" : ""} ${!isActive ? "pointer-events-none" : ""}`,
      showNavigation: isActive,
    };
  };

  // Helper function to get "+ Add" button props (type and className)
  const getAddButtonProps = (cardType, index) => {
    const isActive = addDrugClass === `${index}_${cardType}` && showCardiacCreateSlider;
    return {
      type: isActive ? "primary" : "primary-outline",
      className: `!w-[129px] ${
        isActive
          ? "!bg-REELTeal text-white"
          : "!bg-white !text-REELTeal !border-REELTeal"
      }`
    };
  };


  const renderTooltipIcon = (tooltipId) => (
    <ReactSVG
      src="/icons/information-dark.svg"
      className="w-5 ml-3"
      data-tooltip-id={tooltipId}
    />
  );

  const renderTooltip = (id, content, className = "bg-white p-2 text-teal-300 text-body-sm max-w-[460px]") => (
    <NewToolTip
      id={id}
      render={() => (
        <p className={className}>
          {content}
        </p>
      )}
    />
  );

  const renderOptionButton = (option, config, isSelected, isInCreateVals, onSelect, onCreateVal, scrollOffset = 0) => {
    const tooltip = config.tooltips?.[option.value];
    const showAddButton = isSelected && option.value !== "None" && (!config.excludeValues || !config.excludeValues.includes(option.value));
    
    return (
      <>
        <button
          onClick={() => {
            onSelect(option.value);
            if (scrollOffset !== 0) {
              setTimeout(() => scrollX("drug-induced", scrollOffset), 400);
            }
          }}
          className={`text-base rounded-[4px] border-[1px] text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600 ${
            isSelected ? "bg-gray-20 border-gray-600" : "bg-white border-gray-100"
          } ${option.value === "Other" ? "!gap-0" : ""}`}
        >
          <div className="flex justify-between">
            <p className={`items-center p-3 text-base flex ${config.isSingleSelect ? "" : "text-start"}`}>
              {option.header}
              {tooltip && renderTooltipIcon(tooltip.id)}
            </p>
            {showAddButton && (
              <Button
                type={isInCreateVals ? "primary" : "primary-outline"}
                className={`!w-[129px] ${
                  isInCreateVals
                    ? "!bg-REELTeal text-white"
                    : "!bg-white !text-REELTeal !border-REELTeal"
                }`}
                text="+ Add"
                onClick={(e) => {
                  e.stopPropagation();
                  onCreateVal(e, option.value);
                }}
              />
            )}
          </div>
        </button>
        {tooltip && renderTooltip(tooltip.id, tooltip.content, tooltip.className)}
      </>
    );
  };

  const handleCardiac = () => {
    const nextCard = getNextCard(1);
    if (nextCard) setDrugInducedCard(nextCard);
    else setShowClinicalAnalysis(true);
  };

  const handleOral = () => {
    const nextCard = getNextCard(2);
    if (nextCard) setDrugInducedCard(nextCard);
    else setShowClinicalAnalysis(true);
  };

  const handleOtherPres = () => {
    const nextCard = getNextCard(3);
    if (nextCard) setDrugInducedCard(nextCard);
    else setShowClinicalAnalysis(true);
  };

  const handleNonPres = () => {
    setShowClinicalAnalysis(true);
  };




  const determineAlert = () => {
    const conditions = {
      noCardiac: cardiacVals.includes("None"),
      isOral: oralVal === "Yes",
      noOther: otherPresVals.includes("None"),
      isNasal: otherPresVals.includes("Nasal Decongestants"),
      noNonMed: nonPresVals.includes("None"),
    };

    if (continueService) return null;

    // No prescription meds scenario
    if (!prescriptionMeds) {
      if (!nonPrescriptionMeds || conditions.noNonMed) {
        return "noDrug";
      }
      return "multiCond";
    }

    // Has prescription meds
    const hasNonPresMeds = nonPrescriptionMeds;
    const allNone = conditions.noCardiac && !conditions.isOral && conditions.noOther && (!hasNonPresMeds || conditions.noNonMed);

    if (allNone) return "noDrug";
    if (conditions.noCardiac && conditions.isOral && conditions.noOther && (!hasNonPresMeds || conditions.noNonMed)) {
      return "oral";
    }
    if (conditions.noCardiac && !conditions.isOral && conditions.isNasal && (!hasNonPresMeds || conditions.noNonMed)) {
      return "nasal";
    }
    return "multiCond";
  };

  const handleAlerts = () => {
    const alertType = determineAlert();
    const alertMap = {
      noDrug: () => setOpenNoDrugDialog(true),
      oral: () => setOpenDrugInducedOralAlert(true),
      nasal: () => setOpenDrugInducedNasalAlert(true),
      multiCond: () => setOpenDrugInducedMultiCondAlert(true),
    };
    alertMap[alertType]?.();
  };

  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 bg-white">
      <div className="flex flex-col flex-1">
        <div className="flex flex-1 gap-4">
          <ChartNav />
          <Medications />
          <div className="flex flex-1 w-full h-[668px] overflow-y-auto scroll-smooth ">
            <div className="w-full gap-5">
              <div className="flex items-center justify-between mt-0.5 mb-0.5">
                <h4 className="text-xs-display font-bold text-teal-300">
                  Drug-Induced Allergic Rhinitis
                </h4>
                <SubNavigation />
              </div>
              <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
              <div
                className="grid grid-flow-col auto-cols-[480px] gap-6 scroll-smooth overflow-auto"
                id="drug-induced"
              >
                {/* Cardiac Medications */}
                {prescriptionMeds && (
                  <div>
                    <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div
                        className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                        style={{
                          backgroundImage: `url(/icons/texture-background-2.png)`,
                        }}
                      >
                        <p className="flex text-xl font-bold text-teal-600">
                          {CARD_CONFIG[1].title}
                        </p>
                      </div>
                      <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                        <div className="flex flex-col gap-4">
                          <p className="text-lg h-[51px] font-semibold text-gray-800">
                            {CARD_CONFIG[1].enum.question}
                          </p>
                          <div className="flex flex-col gap-2">
                            {CARD_CONFIG[1].enum.options.map((option, i) => {
                              const isSelected = cardiacVals.includes(option.value);
                              const isInCreateVals = cardiacCreateVals.some((item) => item.name === option.value);
                              const tooltip = CARD_CONFIG[1].tooltips?.[option.value];
                              
                              return (
                                <button
                                  key={option.value}
                                  onClick={() => {
                                    cardiacMultiSelection(option.value);
                                    setTimeout(() => scrollX("drug-induced", -900), 400);
                                  }}
                                  className={`text-base rounded-[4px] border-[1px] text-gray-800 hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600 ${
                                    isSelected ? "bg-gray-20 border-gray-600" : "bg-white border-gray-100"
                                  }`}
                                >
                                  <div className="flex justify-between">
                                    <p className="items-center p-3 text-base flex">
                                      {option.header}
                                      {tooltip && renderTooltipIcon(tooltip.id)}
                                    </p>
                                    {isSelected && option.value !== "None" && (
                                      <Button
                                        {...getAddButtonProps("cardiac", i)}
                                        text="+ Add"
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          cardiacCreateMultiSelection(e, option.value, i);
                                        }}
                                      />
                                    )}
                                  </div>
                                  {tooltip && renderTooltip(tooltip.id, tooltip.content)}
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Oral Contraceptives */}
                {prescriptionMeds && (
                  <div>
                    <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div
                        className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                        style={{
                          backgroundImage: `url(/icons/texture-background-2.png)`,
                        }}
                      >
                        <h3 className="text-xl flex font-bold text-teal-600 ">
                          Oral Contraceptives
                        </h3>
                      </div>
                      <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                        <div className="flex flex-col gap-4">
                          <p className="text-lg h-[51px] font-semibold text-gray-800">
                            {oralMedEnum.question}
                          </p>
                          <div className="flex flex-col gap-2">
                            {oralMedEnum.options.map((option, i) => {
                              const isSelected = oralVal === option.value;
                              const isInCreateVals = oralCreateVals.some((item) => item.name === option.value);
                              
                              return (
                                <button
                                  onClick={() => {
                                    oralMultiSelection(option.value);
                                    setTimeout(() => {
                                      scrollX("drug-induced", -900);
                                    }, 400);
                                  }}
                                  className={`"text-base rounded-[4px] border-[1px] text-gray-800 
                                    hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600" 
                                  ${
                                    isSelected
                                      ? "bg-gray-20 border-gray-600"
                                      : "bg-white border-gray-100"
                                  }`}
                                >
                                  <div className="flex justify-between">
                                    <p className="items-center p-3 text-base flex">
                                      {option.header}
                                    </p>
                                    {isSelected &&
                                      option.value !== "Does not apply" &&
                                      option.value !== "No" && (
                                        <Button
                                          {...getAddButtonProps("oral", i)}
                                          text={"+ Add"}
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            oralCreateMultiSelection(
                                              event,
                                              option.value,
                                              i
                                            );
                                          }}
                                        />
                                      )}
                                  </div>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Other Prescription Medications */}
                {prescriptionMeds && (
                  <div>
                    <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div
                        className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                        style={{
                          backgroundImage: `url(/icons/texture-background-2.png)`,
                        }}
                      >
                        <h3 className="text-xl flex font-bold text-teal-600 ">
                          Other Prescription Medications
                        </h3>
                      </div>
                      <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                        <div className="flex flex-col gap-4">
                          <p className="text-lg h-[51px] font-semibold text-gray-800">
                            {otherPresEnum.question}
                          </p>
                          <div className="flex flex-col gap-2">
                            {otherPresEnum.options.map((option, i) => {
                              const isSelected = otherPresVals.includes(option.value);
                              const isInCreateVals = otherPresCreateVals.some((item) => item.name === option.value);
                              
                              return (
                                <button
                                  onClick={() => {
                                    otherPresMultiSelection(option.value);
                                    setTimeout(() => {
                                      scrollX("drug-induced", 900);
                                    }, 400);
                                  }}
                                  className={`"font-semibold text-body-md rounded-[4px] border-[1px] text-gray-800 
                                  hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600"
                                  ${
                                    isSelected
                                      ? "bg-gray-20 border-gray-600"
                                      : "bg-white border-gray-100"
                                  }`}
                                >
                                  <div className="flex justify-between">
                                    <p className="items-center text-start p-3 text-base flex">
                                      {option.header}{" "}
                                      {option.value === "NSAIDS" && (
                                        <ReactSVG
                                          src="/icons/information-dark.svg"
                                          className="w-5 ml-3"
                                          data-tooltip-id="otherNsaids"
                                        />
                                      )}
                                      {option.value === "Nasal" && (
                                        <ReactSVG
                                          src="/icons/information-dark.svg"
                                          className="w-5 ml-3"
                                          data-tooltip-id="otherNasal"
                                        />
                                      )}
                                    </p>
                                    {isSelected &&
                                      option.value !== "None" && (
                                        <Button
                                          {...getAddButtonProps("otherPres", i)}
                                          text={"+ Add"}
                                          onClick={(event) => {
                                            event.stopPropagation();
                                            otherPresCreateMultiSelection(
                                              event,
                                              option.value,
                                              i
                                            );
                                            setDrugInducedObj({
                                              ...drugInducedObj,
                                              otherPresVals: otherPresVals,
                                            });
                                            setIsOtherPresUpdate(false);
                                          }}
                                        />
                                      )}
                                  </div>
                                  <NewToolTip
                                    id={"otherNsaids"}
                                    render={() => (
                                      <p className="bg-gray-10 p-2 text-teal-300 text-body-sm max-w-[460px]">
                                        Non-steroidal anti-inflammatory drugs
                                      </p>
                                    )}
                                  />
                                  <NewToolTip
                                    id={"alphaBlockerNote"}
                                    render={() => (
                                      <p className="bg-gray-10 p-2 text-teal-300 text-body-sm max-w-[460px]">
                                        Doxazosin, Prazosin
                                      </p>
                                    )}
                                  />
                                  <NewToolTip
                                    id={"otherNasal"}
                                    render={() => (
                                      <p className="bg-gray-10 p-2 text-teal-300 text-body-sm max-w-[460px]">
                                        If using more than 3 to 7 days
                                      </p>
                                    )}
                                  />
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Non-Prescription Medications */}
                {nonPrescriptionMeds && (
                  <div>
                    <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                      <div
                        className="items-center justify-start flex flex-row px-5 py-4 bg-cover bg-center"
                        style={{
                          backgroundImage: `url(/icons/texture-background-2.png)`,
                        }}
                      >
                        <h3 className="text-xl flex font-bold text-teal-600 ">
                          Non-Prescription Medications
                        </h3>
                      </div>
                      <div className="flex flex-col gap-5 p-5 overflow-scroll overflow-x-hidden bg-scroll min-h-[465px]">
                        <div className="flex flex-col gap-4">
                          <p className="text-lg h-[51px] font-semibold text-gray-800">
                            {nonPresEnum.question}
                          </p>
                          <div className="flex flex-col gap-2">
                            {nonPresEnum.options.map((option, i) => {
                              const isSelected = nonPresVals.includes(option.value);
                              const isInCreateVals = nonPresCreateVals.some((item) => item.name === option.value);
                              
                              return (
                                <>
                                  <button
                                    onClick={() => {
                                      nonPresMultiSelection(option.value);
                                      setTimeout(() => {
                                        scrollX("drug-induced", 900);
                                      }, 400);
                                    }}
                                    className={`"font-semibold text-body-md rounded-[4px] border-[1px] text-gray-800 
                                    hover:text-gray-800 hover:bg-gray-20 hover:border-gray-600" 
                                    ${
                                      isSelected
                                        ? "bg-gray-20 border-gray-600"
                                        : "bg-white border-gray-100"
                                    } ${
                                      option.value === "Other" ? "!gap-0" : ""
                                    }`}
                                  >
                                    <div className="flex justify-between">
                                      <p className="items-center text-start p-3 text-base flex">
                                        {option.header}{" "}
                                        {option.value ===
                                          "Nasal Decongestants" && (
                                          <ReactSVG
                                            src="/icons/information-dark.svg"
                                            className="w-5 ml-3"
                                            data-tooltip-id="nasalDecongestants"
                                          />
                                        )}
                                        {option.value === "NSAIDS" && (
                                          <ReactSVG
                                            src="/icons/information-dark.svg"
                                            className="w-5 ml-3"
                                            data-tooltip-id="nsaids"
                                          />
                                        )}
                                      </p>
                                      {isSelected &&
                                        option.value !== "None" && (
                                          <Button
                                            {...getAddButtonProps("nonPres", i)}
                                            text={"+ Add"}
                                            onClick={(event) => {
                                              event.stopPropagation();
                                              nonPresCreateMultiSelection(
                                                event,
                                                option.value,
                                                i
                                              );
                                            }}
                                          />
                                        )}
                                    </div>
                                    <NewToolTip
                                      id={"nasalDecongestants"}
                                      render={() => (
                                        <p className="p-4 text-teal-300 bg-gray-10 text-body-sm">
                                          If using more than 3 to 7 days
                                        </p>
                                      )}
                                    />
                                    <NewToolTip
                                      id={"nsaids"}
                                      render={() => (
                                        <p className="bg-gray-10 p-2 text-teal-300 text-body-sm max-w-[460px]">
                                          Non-steroidal anti-inflammatory drugs
                                        </p>
                                      )}
                                    />
                                  </button>
                                </>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {/* Clinical Analysis */}
                {showclinicalAnalysis && (
                  <div className="h-[585px] rounded-[4px] overflow-hidden border border-gray-100 flex flex-col">
                    <div className="flex flex-row justify-start rounded-s">
                      <button
                        className="m-2 h-4 w-auto rounded-full bg-REELTeal border-REELTeal hover:bg-teal-200 text-white inline-flex border transition-all duration-300 items-center font-semibold justify-center px-2 py-4"
                        onClick={() => {
                          setOpenPrescriptionMedicationAlert(true);
                        }}
                        data-tooltip-id="reviewcard"
                      >
                        <ChevronLeftIcon className="w-4 h-4 text-white" />
                      </button>
                      <NewToolTip
                        id={"reviewcard"}
                        render={() => noteDescription}
                      />
                    </div>
                    <div className="m-8 h-[420px] w-[420px] bg-blue-100 rounded-full flex items-center justify-center bg-opacity-40">
                      <ReactSVG
                        src={"/icons/analysis-pad.svg"}
                        className={``}
                      />
                    </div>
                    <div className="mx-7 my-5">
                      {!clinicalAnalysis && (
                        <Button
                          className="w-full !px-2 !text-xl"
                          type="primary"
                          text="Drug-Induced Allergic 
                            Rhinitis Results"
                          onClick={() => {
                            handleAlerts();
                            setIsCardiacUpdate(false);
                            setIsOralUpdate(false);
                            setIsOtherPresUpdate(false);
                            setIsNonPresUpdate(false);
                          }}
                        />
                      )}
                      {clinicalAnalysis && (
                        <h4 className="text-xl text-center text-REELTeal font-bold items-center justify-center flex">
                          Drug Induced Review Complete
                        </h4>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <PrescriptionMedicationsAlert
              open={openPrescriptionMedicationAlert}
              handleClose={() => {
                setOpenPrescriptionMedicationAlert(false);
              }}
              confirmAction={(rx, nonRx) => {
                if (prescriptionMeds !== rx || nonPrescriptionMeds !== nonRx) {
                  setPrescriptionMeds(rx);
                  setNonPrescriptionMeds(nonRx);
                  setClinicalAnalysis(false);
                  setContinueService(false);
                  setShowClinicalAnalysis(false);

                  // Set initial card: Cardiac (1) if prescription meds, otherwise Non-Prescription (4)
                  setDrugInducedCard(rx ? 1 : nonRx ? 4 : 1);
                  setPrescriptionMedication(true);
                  setCompleteSubStep(false);
                }
                setOpenPrescriptionMedicationAlert(false);
                if (!rx && !nonRx) {
                  setOpenNoDrugDialog(true);
                }
              }}
              q1={prescriptionMeds}
              q2={nonPrescriptionMeds}
            />
            <EndServiceModel
              open={openNoDrugDialog}
              title="Drug-Induced Allergic Rhinitis Alert"
              showEndServiceAndRef={false}
              showOTCConsultAndRef={false}
              className="w-[40%]"
              content={() => <p>No Drugs Identified</p>}
              handleClose={() => {
                setOpenNoDrugDialog(false);
                setContinueService(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref) => {
                setAlertConfirmation(0);
                setAlertExplaination("");
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                setOpenNoDrugDialog(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setContinueService(true);
              }}
            />

            <ConfirmationModalNew
              open={openUncodedDrugAlert}
              title={"Uncoded Drug Alert"}
              type={"primary"}
              confirmText={"Continue"}
              cancelText={"Cancel & Review"}
              content={() => (
                <div className="flex flex-col text-gray-600">
                  <p className="text-body-sm ">
                    An uncoded DRUG has been added.
                    <br />
                    Profile Analysis can not be performed.
                  </p>
                  <p className="text-body-sm mt-4">
                    A manual clinical check will be required.
                  </p>
                </div>
              )}
              onCross={() => setOpenUncodedDrugAlert(false)}
              handleClose={() => setOpenUncodedDrugAlert(false)}
              confirmAction={() => {
                setOpenUncodedDrugAlert(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
              }}
            />

            <EndServiceModel
              open={openDrugInducedNasalAlert}
              title="Drug-Induced Allergic Rhinitis Alert"
              showEndServiceAndRef={false}
              showOTCConsultAndRef={false}
              content={() => (
                <div className="flex flex-col gap-4">
                  <div class="text-body-md font-semibold">
                    Prolonged Use of Nasal Decongestants
                  </div>
                  {getSelectedMedications()}
                  <div class="text-sm flex flex-col gap-4">
                    <p>
                      Symptoms caused by Nasal Decongestants used for<br></br>
                      longer than 3 to 7 days.
                      <br></br>
                      <br></br>
                      Suggest to discontinue with a tapering schedule.
                    </p>
                  </div>
                </div>
              )}
              handleClose={() => {
                setContinueService(false);
                setOpenDrugInducedNasalAlert(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref, exp) => {
                setAlertConfirmation(
                  ref
                    ? AlertConfirmationTypes.ContinueWithRefer
                    : AlertConfirmationTypes.ContinueWithNoReferral
                );
                setAlertExplaination(exp);
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                setIsContinueClicked(true);
                setOpenDrugInducedNasalAlert(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setContinueService(true);
              }}
            />
            <EndServiceModel
              open={openDrugInducedMultiCondAlert}
              title="Drug-Induced Allergic Rhinitis Alert"
              content={() => (
                <div className="flex flex-col gap-4">
                  <div class="text-body-md font-semibold text-gray-600">
                    Possible Allergic Rhinitis with start of new medications
                    within the last 3 months.
                  </div>
                  {getSelectedMedications()}
                </div>
              )}
              handleClose={() => {
                setContinueService(false);
                setOpenDrugInducedMultiCondAlert(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref, exp) => {
                setAlertConfirmation(
                  ref
                    ? AlertConfirmationTypes.ContinueWithRefer
                    : AlertConfirmationTypes.ContinueWithNoReferral
                );
                setAlertExplaination(exp);
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                updateStepsVisibility(false);
                setIsContinueClicked(true);
                setOpenDrugInducedMultiCondAlert(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setContinueService(true);
              }}
              handleEndService={() => {
                setShowRef(true);
                setAlertConfirmation(AlertConfirmationTypes.EndService);
                setAlertExplaination("");
                setOpenDrugInducedMultiCondAlert(false);
                updateStepsVisibility(true);
                setClickedEndService(true);
              }}
            />
            <EndServiceModel
              open={openDrugInducedOralAlert}
              title="Drug-Induced Allergic Rhinitis Alert"
              content={() => (
                <div className="flex flex-col gap-4">
                  <div class="text-body-md font-semibold">
                    Possible Hormonal Rhinitis identified
                  </div>
                  {getSelectedMedications()}
                  <div class="text-sm flex flex-col gap-4">
                    <p>
                      Allergic Rhinitis symptoms coincide with start of{" "}
                      <b>Oral Contraceptives</b>
                      <br></br>
                    </p>
                  </div>
                </div>
              )}
              handleClose={() => {
                setContinueService(false);
                setOpenDrugInducedOralAlert(false);
                setAlertConfirmation(0);
                setAlertExplaination("");
              }}
              handleContinue={(ref, exp) => {
                setAlertConfirmation(
                  ref
                    ? AlertConfirmationTypes.ContinueWithRefer
                    : AlertConfirmationTypes.ContinueWithNoReferral
                );
                setAlertExplaination(exp);
                if (ref !== undefined) {
                  setShowRef(ref);
                }
                updateStepsVisibility(false);
                setIsContinueClicked(true);
                setOpenDrugInducedOralAlert(false);
                setClinicalAnalysis(true);
                setCompleteSubStep(true);
                setContinueService(true);
              }}
              handleEndService={() => {
                setShowRef(true);
                setAlertConfirmation(AlertConfirmationTypes.EndService);
                setAlertExplaination("");
                setOpenDrugInducedOralAlert(false);
                updateStepsVisibility(true);
                setClickedEndService(true);
              }}
            />

            {/* Drug Induced Medical Condition Models */}
            <MedicationCreate
              isRxService={true}
              title={title}
              allMedications={medications}
              create={
                !medications?.some(
                  (i) => i.medicationName === selectedMedication
                )
              }
              fullMedication={
                medications?.filter(
                  (i) => i.medicationName === selectedMedication
                )[0]
              }
              patientId={patientId}
              open={showCardiacCreateSlider}
              maxSteps={maxStep}
              medicationName={selectedMedication}
              showSaveAndAddAnother={false}
              onClose={(value) => {
                setShowCardiacCreateSlider(value);
                setAddDrugClass(null);
                setSelectedMedication(null);
                setMedicationType(null);
                setTitle(null);
                setCurrentCardType(null);
                setMedicationStepCount(null);
              }}
              onSkip={() => {
                setShowCardiacCreateSlider(false);
                setAddDrugClass(null);
                setSelectedMedication(null);
                setMedicationType(null);
                setTitle(null);
                setCurrentCardType(null);
                setMedicationStepCount(null);
              }}
              onSave={(medicationName) => {
                if (selectedMedication === "Other") {
                  setOtherDrugs([...otherDrugs, medicationName]);
                }
                setTimeout(() => {
                  dispatch(fetchMedications(patientId));
                }, 500);
                setShowCardiacCreateSlider(false);
                setAddDrugClass(null);
                setSelectedMedication(null);
                setMedicationType(null);
                setTitle(null);
                setCurrentCardType(null);
                setMedicationStepCount(null);
              }}
            />
          </div>
        </div>
      </div>

      <div className="flex items-center justify-between space-x-4  rounded">
        <div className="w-full ">
          <Steps position="bottom" stepsList={clinicalServiceSteps} />
        </div>
        <div className="flex items-center gap-3 ">
          <Button
            type="primary-outline"
            text="Back"
            className="w-[200px] max-h-[52px] !rounded-[30px]"
            onClick={() => {
              onPrevious();
            }}
          />
          <Button
            type="primary"
            text="Next"
            className={`w-[200px] max-h-[52px] !rounded-[30px] ${
              !completeSubStep && "opacity-40 pointer-events-none"
            }`}
            onClick={() => {
              onNext();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default DrugInduced;
